/**
 * @file コンポーネント：フル動画ページ利用規約モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Terms } from "~/src/components/projects/Terms";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            content={[<Terms frameScroll={true} key="terms" onColor="white" />]}
            hasButtonClose={true}
            headline={localized["Label.Terms"]}
            isShow={props.isOpenModalTerms}
            setIsShow={props.setIsOpenModalTerms}
        />
    );
};
